import { useSupabaseAuth, AuthContextValue } from '@/lib/auth';

/**
 * Custom auth hook using native Supabase Auth.
 * Provides a consistent interface for the rest of the application.
 */
export const useAuth = (): AuthContextValue => {
  return useSupabaseAuth();
};
